import uniqid from 'uniqid'
import { skills } from '../../data'
import './Skills.css'

const Skills = () => {
  if (!skills.length) return null
  const skillGroups = [
    {
      title: 'Frontend',
      items: [
        'HTML5',
        'CSS3',
        'JavaScript',
        'React.js',
        'Next.js',
        'SCSS',
        'MUI',
        'Bootstrap',
        'React-bootstrap',
        'Storybook',
      ],
    },
    {
      title: 'Backend & CMS',
      items: ['Node.js', 'Express.js', 'REST APIs', 'Strapi CMS', 'HubSpot CRM', 'PostgreSQL'],
    },
    {
      title: 'Workflow',
      items: ['Git', 'GitHub', 'Postman', 'Figma', 'Jira', 'Slack', 'VS Code', 'Open Source'],
    },
  ]

  return (
    <section className='section skills' id='skills'>
      <h2 className='section__title'>Skills</h2>
      <p className='section__lead'>
        Practical tools I use to make products shippable, debuggable, and easier
        to adopt.
      </p>
      <div className='skills__groups'>
        {skillGroups.map((group) => (
          <section key={group.title} className='skills__group'>
            <h3 className='skills__group-title'>{group.title}</h3>
            <ul className='skills__list'>
              {group.items
                .filter((skill) => skills.includes(skill))
                .map((skill) => (
                  <li key={uniqid()} className='skills__list-item btn btn--plain'>
                    {skill}
                  </li>
                ))}
            </ul>
          </section>
        ))}
      </div>
    </section>
  )
}

export default Skills
